import { DashboardPage } from './DashboardPage';
import { SuccessPage } from './SuccessPage';
import type { PurchaseHistory } from '../modules/DataTransformSchema';

// Mock e-receipts so the dashboard renders without a real connection.
const MOCK_ORDERS: PurchaseHistory[] = [
  {
    product_name: 'Clorox Disinfecting Wipes, 225 ct (3-pack)',
    product_image:
      'https://m.media-amazon.com/images/I/81mYDgcDORL._AC_SL1500_.jpg',
    product_price: '$14.97',
    order_total: '$14.97',
    order_date: 'May 28, 2026',
    quantity: 1,
  },
  {
    product_name: 'Tide PODS Laundry Detergent, 81 ct',
    product_image:
      'https://m.media-amazon.com/images/I/81qVv2nP1zL._AC_SL1500_.jpg',
    product_price: '$22.49',
    order_total: '$22.49',
    order_date: 'May 14, 2026',
    quantity: 1,
  },
  {
    product_name: 'Dawn Ultra Dish Soap, 56 fl oz',
    product_image:
      'https://m.media-amazon.com/images/I/71xH7eMQ0BL._AC_SL1500_.jpg',
    product_price: '$9.94',
    order_total: '$9.94',
    order_date: 'Apr 30, 2026',
    quantity: 1,
  },
  {
    product_name: 'Pine-Sol Multi-Surface Cleaner, 100 oz',
    product_image:
      'https://m.media-amazon.com/images/I/81vTbz9Dq5L._AC_SL1500_.jpg',
    product_price: '$8.97',
    order_total: '$8.97',
    order_date: 'Feb 18, 2026',
    quantity: 1,
  },
];

const MOCK_SESSION_ID = 'debug-session-ABCDE12345';

// Two debug entry points mirroring the real flow:
//   confirmation-code → success screen with the confirmation code (SuccessPage)
//   view-data         → purchases dashboard (DashboardPage)
export function DebugDashboardPage({
  view,
}: {
  view: 'confirmation-code' | 'view-data';
}) {
  if (view === 'confirmation-code') {
    return (
      <SuccessPage
        isExternalCompletionUser={false}
        showPostConnectSurvey={false}
        sessionId={MOCK_SESSION_ID}
      />
    );
  }

  return (
    <DashboardPage
      orders={MOCK_ORDERS}
      sessionId={MOCK_SESSION_ID}
      startConfirmed={true}
      isEmpty={false}
      isLoadingMore={false}
      isQuestionProTask={false}
    />
  );
}
